import { AbstractControl, ValidatorFn } from '@angular/forms';

export const ConfirmPasswordValidator: ValidatorFn = (control: AbstractControl): { [key: string]: unknown } | null => {
    const password = control.parent?.get("password")?.value;
    return password === control.value ? null : { notConfirmed: true };
};
